var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import triggerAnalytics from './trigger-analytics';
var triggerManageCardHoldersSamsAnalytics = function (params) {
    return triggerAnalytics(__assign({ pageFunction: 'auth user', pageKind: 'account services' }, params));
};
export default triggerManageCardHoldersSamsAnalytics;
